var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortlistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66699 3.33333C4.49018 3.33333 4.32061 3.40357 4.19559 3.5286C4.07056 3.65362 4.00033 3.82319 4.00033 4V12C4.00033 12.1768 4.07056 12.3464 4.19559 12.4714C4.32061 12.5964 4.49018 12.6667 4.66699 12.6667H6.41033C6.77851 12.6667 7.07699 12.9651 7.07699 13.3333C7.07699 13.7015 6.77851 14 6.41033 14H4.66699C4.13656 14 3.62785 13.7893 3.25278 13.4142C2.87771 13.0391 2.66699 12.5304 2.66699 12V4C2.66699 3.46957 2.87771 2.96086 3.25278 2.58579C3.62785 2.21071 4.13656 2 4.66699 2H10.0003C10.5308 2 11.0395 2.21071 11.4145 2.58579C11.7896 2.96086 12.0003 3.46957 12.0003 4V9.33333C12.0003 9.70152 11.7018 10 11.3337 10C10.9655 10 10.667 9.70152 10.667 9.33333V4C10.667 3.82319 10.5968 3.65362 10.4717 3.5286C10.3467 3.40357 10.1771 3.33333 10.0003 3.33333H4.66699Z",
    fill: "#737373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8051 10.8613C14.0654 11.1216 14.0654 11.5437 13.8051 11.8041L11.1384 14.4708C10.878 14.7311 10.4559 14.7311 10.1956 14.4708L8.86225 13.1374C8.6019 12.8771 8.6019 12.455 8.86225 12.1946C9.1226 11.9343 9.54471 11.9343 9.80506 12.1946L10.667 13.0565L12.8623 10.8613C13.1226 10.6009 13.5447 10.6009 13.8051 10.8613Z",
    fill: "#737373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 5.33268C5.33301 4.96449 5.63148 4.66602 5.99967 4.66602H8.66634C9.03453 4.66602 9.33301 4.96449 9.33301 5.33268C9.33301 5.70087 9.03453 5.99935 8.66634 5.99935H5.99967C5.63148 5.99935 5.33301 5.70087 5.33301 5.33268Z",
    fill: "#737373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 8.00065C5.33301 7.63246 5.63148 7.33398 5.99967 7.33398H7.33301C7.7012 7.33398 7.99967 7.63246 7.99967 8.00065C7.99967 8.36884 7.7012 8.66732 7.33301 8.66732H5.99967C5.63148 8.66732 5.33301 8.36884 5.33301 8.00065Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortlistIcon);
export default __webpack_public_path__ + "static/media/ShortlistIcon.1d8e4e8cb8b7805074bfd5fc06dd2661.svg";
export { ForwardRef as ReactComponent };